import { reduce } from 'lodash';

export function getCostPerIngredient(ingredient) {
  const { amountPerPackage, costPerPackage, amountPerformula } = ingredient;
  return (costPerPackage / amountPerPackage) * amountPerformula;
}

export function getTotalCost(ingredients) {
  return reduce(
    ingredients,
    (result, ingredient) => {
      const cost = getCostPerIngredient(ingredient);
      return result + cost;
    },
    0
  );
}
